export const getTimeDifferenceInMinutes = (time1: string, time2: string): number | undefined => {
    // Validate time format (HH:MM) - allowing hours up to 34 for bus timetables
    const timeRegex = /^([0-2]?[0-9]|3[0-4]):([0-5][0-9])$/

    if (!timeRegex.test(time1) || !timeRegex.test(time2)) {
        return undefined
    }

    // Parse time strings
    const [hours1, minutes1] = time1.split(':').map(Number)
    const [hours2, minutes2] = time2.split(':').map(Number)

    // Convert to total minutes
    const totalMinutes1 = hours1 * 60 + minutes1
    const totalMinutes2 = hours2 * 60 + minutes2

    // Return difference (time2 - time1)
    return totalMinutes2 - totalMinutes1
}
